import { internalErrorCodes } from "../utils";
const errorPrefix = "Dashboard:";

export function missingToken() {
	const error = new Error(`${errorPrefix} Access token or Refresh token not found`);
	error.code = internalErrorCodes.MISSING_TOKEN;
	throw error;
}

export default {
	missingToken,
};



// WEBPACK FOOTER //
// ./src/utils/throws.js